.membership-card-pub-list {
  text-align: center;
}
.membership-card-pub-list li {
  border: solid 1px #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
}
.membership-card-pub-list .membership-card-pub {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  right: 15px;
}
.membership-card-pub-list .membership-card-pub .card-info-lightbulb {
  margin: 0 15px 10px 0;
  font-size: 24px;
}
.membership-card-pub-list .membership-card-pub .alert-info {
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  border-radius: 10px;
  border: none;
  padding: 15px;
}

@media screen and (max-width: 800px) {
  .membership-card-pub-list li {
    padding: 5px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL2J1eXRpY2tldHMiLCJzb3VyY2VzIjpbIm1lbWJlcnNoaXAtY2FyZC1wdWIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJOztBQUVBO0VBQ0k7RUFDQTtFQUNBO0VBQ0E7O0FBR0o7RUFDSTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0k7RUFDQTs7QUFHSjtFQUNJO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBS1o7RUFFUTtJQUNJIiwic291cmNlc0NvbnRlbnQiOlsiLm1lbWJlcnNoaXAtY2FyZC1wdWItbGlzdCB7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyOyAgXG5cbiAgICBsaSB7XG4gICAgICAgIGJvcmRlcjogc29saWQgMXB4ICNjY2M7XG4gICAgICAgIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgICAgICAgcGFkZGluZzogMTBweDtcbiAgICB9XG5cbiAgICAubWVtYmVyc2hpcC1jYXJkLXB1YiB7XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAgIHJpZ2h0OiAxNXB4O1xuXG4gICAgICAgIC5jYXJkLWluZm8tbGlnaHRidWxiIHtcbiAgICAgICAgICAgIG1hcmdpbjogMCAxNXB4IDEwcHggMDtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogMjRweDtcbiAgICAgICAgfVxuXG4gICAgICAgIC5hbGVydC1pbmZvIHtcbiAgICAgICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgICAgICAgZm9udC1zaXplOiAxNHB4O1xuICAgICAgICAgICAgZm9udC13ZWlnaHQ6IDcwMDtcbiAgICAgICAgICAgIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gICAgICAgICAgICBib3JkZXI6IG5vbmU7XG4gICAgICAgICAgICBwYWRkaW5nOiAxNXB4O1xuICAgICAgICB9XG4gICAgfVxufVxuXG5AbWVkaWEgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiA4MDBweCkge1xuICAgIC5tZW1iZXJzaGlwLWNhcmQtcHViLWxpc3Qge1xuICAgICAgICBsaSB7XG4gICAgICAgICAgICBwYWRkaW5nOiA1cHg7XG4gICAgICAgIH1cbiAgICB9XG59Il19 */